import RestService from './RestService';

async function getArticle(articleId) {
	const res = await RestService.performRestOpNext(`authorizer/article/get-raw`, {
		articleId
	});


	return res;
}

async function createArticle(article) {
	console.log(article);
	const res = await RestService.performRestOpNext(`authorizer/article/create`, article);
	console.log(res);
	return res.articleId;
}

async function updateArticle(article) {
	console.log(article);
	const res = await RestService.performRestOpNext(`authorizer/article/update`, article);
	console.log(res);
	return res;
}

async function translateArticle(articleId, targetLanguage) {
	const translatedArticle = await RestService.performRestOpNext(`authorizer/article/translate`, {
		articleId,
		targetLanguage
	});
	console.log(translatedArticle);
	const createdTranslatedArticle = await createArticle(translatedArticle);
	console.log('translated article id', createdTranslatedArticle);
	const originalArticle = await getArticle(articleId);

	if (originalArticle.languages) {
		originalArticle.languages[targetLanguage] = createdTranslatedArticle;
	} else {
		originalArticle.languages = { [targetLanguage]: createdTranslatedArticle };
	}
	await updateArticle({ ...originalArticle });
}

export default {
	translateArticle,
	getArticle,
	createArticle,
	updateArticle
};
